const base_url = "https://apni-dukaan-uccj.onrender.com";
export default base_url;
//"http://localhost:8000"
//"https://apni-dukaan-uccj.onrender.com"